import React from 'react';
import {
	Box,
	Typography,
	useTheme,
	Card,
	CardActionArea,
	CardMedia,
	CardContent,
	CardActions,
	Button, IconButton
} from '@mui/material';
import {Link} from 'react-router-dom';

interface IProps {
	title: string;
	image: string;
	url?: string;
	state?: any;
	gradient?: boolean;
}

export default function CustomCard({title, image, url, state, gradient}: IProps) {
	const theme = useTheme();
	// @ts-ignore
	const color = theme.palette.primary[800];
	if (url) {
		return (
			<Link to={url} className="relative" state={state}>
				<Card variant="outlined" className="flex w-full h-16">
					<CardMedia
						className="w-16 h-16"
						component="img"
						image={image}
						alt={title}
					/>
					<CardContent className="flex justify-center items-center">
						<Typography sx={{fontSize: (theme) => theme.typography.fontSize + 2}}
						            className="font-medium">{title}</Typography>
					</CardContent>
				</Card>
			</Link>
		);
	} else {
		return (
			<Card variant="outlined" className="flex w-full h-24">
				<CardMedia
					component="img"
					sx={{width: 100}}
					image={image}
					alt={title}
				/>
				<CardContent className="flex justify-center items-center">
					<Typography sx={{fontSize: (theme) => theme.typography.fontSize + 2}}
					            className="font-medium">{title}</Typography>
				</CardContent>
			</Card>
		);
	}
}
